import React from 'react';
import './PlatformIntro.css';

const PlatformIntro = () => {
  return (
    <section className='section-platform'>
      <div className='container-fixed'>
        <p className='all-caps'>
          A platform built around how travelers think<span className='platform-title-rest'>, feel, and spend</span>
        </p>
        <p className='platform-intro-body'>
          Tap into high‑intent traveler behavior and deliver your brand message at the exact
          moments when decisions are made and dollars move.
        </p>
        <div className='arrow-down' onClick={() => document.getElementById('placements')?.scrollIntoView({ behavior: 'smooth' })}>
          <svg viewBox='0 0 24 24'>
            <path d='M12 5v14M5 12l7 7 7-7' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default PlatformIntro;
